module.exports = __webpack_public_path__ + "img/pro_one_4.4edce315.jpg";